
import { ChatMessage, ChatPreview, ChatType } from "@/components/chat/types";
import { UserProfile, UserRole, TeamType } from "@/types/user";

// Utility functions for transforming chat data
export const transformChatPreviewData = (chats: any[]): ChatPreview[] => {
  return chats.map(chat => {
    if (!chat || typeof chat !== 'object') {
      console.error("Invalid chat object in transformChatPreviewData:", chat);
      return null as any; // Handle null case
    }
    
    // Ensure type is properly typed as ChatType
    const chatType = chat.type as ChatType;
    
    return {
      id: chat.id,
      type: chatType,
      groupName: chat.group_name,
      timestamp: new Date(chat.timestamp), // Convert string to Date
      lastMessage: chat.lastMessage,
      unread: false,
      user: chat.user ? {
        id: chat.user.id,
        name: chat.user.display_name || 'Unknown User',
        avatarUrl: chat.user.avatar_url,
        email: chat.user.email,
        role: "individual" as UserRole,
        teamType: "general" as TeamType,
        skills: [],
      } : null,
      members: chat.members || [],
    };
  }).filter(Boolean); // Filter out any null values
};

// Function to transform chat message data
export const transformChatMessageData = (messages: any[]): ChatMessage[] => {
  return messages.map(message => {
    if (!message || typeof message !== 'object') {
      console.error("Invalid message in transformChatMessageData:", message);
      return {
        id: '',
        content: '',
        timestamp: new Date(),
        senderId: '',
        senderName: 'Unknown User',
        senderAvatar: '',
      };
    }
    
    // Now we're sure message is a valid object
    return {
      id: message.id || '',
      content: message.content || '',
      timestamp: message.created_at ? new Date(message.created_at) : new Date(),
      senderId: message.sender_id || '',
      senderName: message.user?.display_name || 'Unknown User',
      senderAvatar: message.user?.avatar_url || `https://api.dicebear.com/7.x/personas/svg?seed=${message.user?.display_name || 'unknown'}&backgroundColor=b6e3f4,c0aede,d1d4f9&radius=50`,
    };
  });
};

// Function to transform a single chat message
export const transformSingleChatMessageData = (message: any): ChatMessage => {
  if (!message || typeof message !== 'object') {
    console.error("Invalid message in transformSingleChatMessageData:", message);
    return {
      id: '',
      content: '',
      timestamp: new Date(),
      senderId: '',
      senderName: 'Unknown User',
      senderAvatar: '',
    };
  }
  
  return {
    id: message.id || '',
    content: message.content || '',
    timestamp: message.created_at ? new Date(message.created_at) : new Date(),
    senderId: message.sender_id || '',
    senderName: message.user?.display_name || 'Unknown User',
    senderAvatar: message.user?.avatar_url || `https://api.dicebear.com/7.x/personas/svg?seed=${message.user?.display_name || 'unknown'}&backgroundColor=b6e3f4,c0aede,d1d4f9&radius=50`,
  };
};
